import {createApp, ref} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import useSetPasswordForm from '../composables/useSetPasswordForm';
import useVuelidate from '@vuelidate/core';
import {helpers, required} from '@vuelidate/validators';
import {postcode} from '../modules/regitValidators';

type Panel = 'vin' | 'recalls' | 'next';

type PanelStateInterface = {[key in Panel]: boolean}

const PanelState: PanelStateInterface = {
    vin: false,
    recalls: false,
    next: false,
};

const app = createApp({
    props: {
        userPostcode: {type: String, default: ''},
        hasPassword: {type: Boolean, default: true},
    },
    data() {
        return {
            panelState: PanelState,
        };
    },
    setup(props) {
        const state = {
            postcode: ref(props.userPostcode || ''),
        };
        const rules = {
            postcode: {
                required: helpers.withMessage('Please enter your postcode', required),
                postcode: helpers.withMessage('Please enter a valid postcode', postcode),
            },
        };


        const v = useVuelidate(rules, state);
        async function submitPostcode(e: Event) {
            e.preventDefault();
            e.stopPropagation();

            const validationPassed = await v.value.$validate();
            if (validationPassed) {
                (document.getElementById('postcodeForm') as HTMLFormElement).submit();
            }
        }

        const {
            showPassword,
            newPassword,
            passwordModalValidator,
            setPassword,
        } = useSetPasswordForm();

        return {
            postcode: state.postcode,
            v$: v,
            submitPostcode,

            showPassword,
            newPassword,
            passwordModalValidator,
            setPassword,
        };
    },
    mounted() {
        if (!this.hasPassword) {
            this.$modal.show('modal-set-password');
        }
    },

    methods: {
        togglePanel(panel: Panel) {
            this.panelState[panel] = !this.panelState[panel];
        },
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);
app.mount('#app');
